import { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'

import history from './history'
import { store } from './redux/store'

import 'react-loading-skeleton/dist/skeleton.css'

import PageLoader from './components/UI/PageLoader/PageLoader'

const LayoutLazy = lazy(() => import('./components/Containers/Layout/Layout'))
const AuthLayoutLazy = lazy(
  () => import('./components/Containers/AuthLayout/AuthLayout')
)

const LoginLazy = lazy(() => import('./components/Pages/Login/Login'))
const NotFoundLazy = lazy(() => import('./components/Pages/NotFound/NotFound'))
const DashboardLazy = lazy(
  () => import('./components/Pages/Dashboard/Dashboard')
)

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<LayoutLazy />}>
              <Route path='/' element={<LoginLazy />} />
              <Route element={<AuthLayoutLazy />}>
                <Route path='/dashboard' element={<DashboardLazy />} />
              </Route>
              <Route path='*' element={<NotFoundLazy history={history} />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}

export default App
